import { ServiceData } from '@/types';

import articles from './COOKING_ARTICLES_EE.json';
import recipes from './COOKING_RECIPES_EE.json';
import videos from './COOKING_VIDEOS_EE.json';

export const COOKING_DATA_EE: ServiceData = {
  articles,
  recipes,
  videos,
};
